import { useState, forwardRef, useEffect, useCallback } from "react";
import { useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller, useFieldArray  } from 'react-hook-form';
import DatosCabezaFamilia from './../../Caracterizacion/DatosCabezaFamilia';
import apiService from '../../../Auth/apiService';
import {NumericFormat} from 'react-number-format';
import Select from 'react-select';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuCaracterizacion from "../Componentes/MenuCaracterizacion";
import { useAuth } from "../../../Auth/AuthContext";
import { BotonBorrar } from "./../../Utils/BotonBorrar.jsx";
import SearchForm from '../../Utils/Searchform.jsx';
import SeccionPageHeader from "../../Utils/SeccionPageHeader.jsx";
import CargandoSpinner from "../../Utils/CargandoSpinner.jsx";import PropTypes from 'prop-types';
import { ConvertErrors422ToString } from './../../Utils/ConvertErrors422ToString.jsx';
import { FaInfoCircle } from "react-icons/fa";

registerLocale('es', es);
setDefaultLocale('es');

const NumberInput = forwardRef((props, ref) => (
    <NumericFormat
      {...props}
      className='form-control'
      getInputRef={ref} 
      thousandSeparator={false}
      decimalScale={0} 
      allowNegative={false}
      customInput="input"
    />
  ));

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }}/>
        <i className="fa fa-calendar"/>
    </button>
));

CustomInput.propTypes = {
    value: PropTypes.any,
    onClick: PropTypes.func,
};

function BorrarBtn(Borraratencion, row){
    return (
        <div>
            <BotonBorrar Borrar={Borraratencion} row={row} />
        </div>
    );
}
export default function CrearAtencionAhe(){
    const [Cargando, setCargando] = useState(false);
    const { token, rol, user, sedeActual } = useAuth();
    const { idCabezaFamilia } = useParams();
    const navigate = useNavigate();
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const [MostrarTiposEntrega, setMostrarTiposEntrega] = useState(false);
    const [MostrarTiposNaturaleza, setMostrarTiposNaturaleza] = useState(false);
    const [disablefields, setDisablefields] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const entidad = watch('entidad');
    const tipoahuid = watch('tipoahuid');
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const { append, remove } = useFieldArray({
        control,
        name: 'atencionesfields'
      });
    const [entidades, setEntidades] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [tiposahu, setTiposahu] = useState([]);
    const [tiposentrega, setTiposentrega] = useState([]);
    const [naturalezas, setNaturalezas] = useState([]);
    const [tiposnaturaleza, setTiposnaturaleza] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    
    const Mensaje = useCallback((title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    }, []);
    const ResetForm = useCallback((cleanList, idcabeza) => {
        const fechahoy = new Date()
        fechahoy.setHours(fechahoy.getHours() - 5)
        setCualesBeneficiariosAHESeleccionados([]);
        reset((prevValues) => ({
            ...prevValues,
            usrId: user,
            cabIdcabezafamilia: idcabeza ?? idCabezaFamilia,
            sedeActual: sedeActual,
            fecha: fechahoy,
            idpersona: idcabeza ?? idCabezaFamilia,
            entidad: 1,
            tipoahuid: '',
            tipoentregaid: '',
            naturalezaid: '',
            cantidad: 0,
            nropersonas: 0,
            nroentrega: 1,
            tiponaturalezaid: '2',
            idayuda: '',
            valorunitario: 0,
            observaciones: '',
            atencionesfields: cleanList ? [] : getValues('atencionesfields')
        }))
        setMostrarTiposNaturaleza(false);
        setMostrarTiposEntrega(false);
        setDisablefields(false);
    }, [reset, idCabezaFamilia, user, sedeActual]);
    const fetchData = useCallback(async (idCabezaFamilia, rol) => {
        if(idCabezaFamilia === '0') return;
        const url = '/ahe/crearformularioregistroatencionahe';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user};
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            ResetForm(true, result.cabezafamilia.cab_idcabezafamilia);
            if (Array.isArray(result.entidades)) {
                setEntidades(result.entidades);
            } else {
                console.error('Invalid data format for entidades:', result.entidades);
            }
            if (Array.isArray(result.integrantesdto)) {
                setIntegrantes(result.integrantesdto);
                const personas = result.integrantesdto.map((integrante) => ({value: integrante.id, label: `${integrante.nombre}`}));
                setPersonas(personas);
            } else {
                console.error('Invalid data format for integrantesdto:', result.integrantesdto);
            }
            if (Array.isArray(result.tiposahu)) {
                setTiposahu(result.tiposahu);
            } else {
                console.error('Invalid data format for tiposahu:', result.tiposahu);
            }
        })
        .catch(error => {
            Mensaje('Atenciones AHE', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia} ${error}`);
        })
        .finally(() => {
            setCargando(false);
        });
    }, [token, Mensaje]);
    useEffect(() => {
        fetchData(idCabezaFamilia, rol);
    }, [idCabezaFamilia, rol, fetchData]);
    const onSubmit = async (data) => {
        const ExisteAtencion = getValues('atencionesfields').find((item) => item.idayuda === data.idayuda && item.idpersona === data.idpersona);
        if(!ExisteAtencion){
            const nombreayuda = ayudas.find((item) => item.id === data.idayuda).ayu_ayuda;
            const nombreentidad = entidades.find((item) => item.id === Number(data.entidad)).entEntidad;
            const personasSeleccionadas = cualesBeneficiariosAHESeleccionados.map(opt => opt.value).join(',')
            append({
                idayuda: data.idayuda, 
                cantidad: data.cantidad, 
                nropersonas: data.nropersonas,
                nroentrega: data.nroentrega,
                valor : Number(data.valorunitario),
                observaciones: data.observaciones,
                fecha: data.fecha, 
                identidad: data.entidad, 
                tipoahuid: data.tipoahuid,
                tipoentregaid : data.tipoentregaid,
                naturalezaid : data.naturalezaid,
                tiponaturalezaid : data.tiponaturalezaid,
                ayuda: nombreayuda, 
                entidad : nombreentidad,
                idpersona: data.idpersona,
                beneficiariosahe: personasSeleccionadas
            });
            setDisablefields(true);
        }else {
            Mensaje('Registrar atencion', "Ya esta registrada esta atencion");
        }
        
    };
    function Borraratencion (row){
        remove(getValues('atencionesfields').indexOf(row));
    };
    const GuardarAtenciones = async () => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/ahe/registraroatencionahe';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify(response.data));
                ResetForm(true);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', ConvertErrors422ToString(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }

      };
    const ActualizarTiposEntrega = async (event) => {
        const url = '/ahe/consultartiposentrega';
        const obj = {tipoahuid: event.target.value }
        try {
            setCargando(true);
            const responsetiposentrega = await apiService.post(url, obj, token);
            const resulttiposentrega = await responsetiposentrega.data;
            setMostrarTiposEntrega(true);
            setTiposentrega(resulttiposentrega);
            setValue('tipoahuid', event.target.value)
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
      };
    const ActualizarNaturalezas = async (event) => {
        const url = '/ahe/consultartiposnaturaleza';
        const obj = {tipoahuid: tipoahuid, tipoentregaid : event.target.value, identidad: entidad }
        try {
            setCargando(true);
            const responsenaturalezas = await apiService.post(url, obj, token);
            const resultnaturalezas = await responsenaturalezas.data;
            setMostrarTiposNaturaleza(true);
            setNaturalezas(resultnaturalezas.tiposnaturaleza);
            setTiposnaturaleza(resultnaturalezas.tiposnaturalezas);
            setAyudas(resultnaturalezas.ayudas);
            setValue('naturalezaid', '2')
            setValue('tiponaturalezaid', '2')
            setValue('idayuda', '')
            setValue('valorunitario', '0')
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
      };
    const ActualizarValorUnitario = async (event) => {
        const ayudaseleccionada = ayudas.find((ayuda) => ayuda.id === event.target.value)
        setValue('valorunitario', ayudaseleccionada.ayu_valor)
        setValue('cantidad', 1);
    };
    const [searchTerm, setSearchTerm] = useState('');
    
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/ahe/crearatencionahe/${searchTerm}`, { replace: true });
        }
    };
    const [cualesBeneficiariosAHESeleccionados, setCualesBeneficiariosAHESeleccionados] = useState([]);
    const ActualizarBeneficiariosAHE = persona => {
        setCualesBeneficiariosAHESeleccionados(persona);
        
    };
    useEffect(() => {
        if (cualesBeneficiariosAHESeleccionados.length > 0) {
            setValue('nropersonas', cualesBeneficiariosAHESeleccionados.length);
        } else {
            setValue('nropersonas', 0);
        }
    }, [cualesBeneficiariosAHESeleccionados, setValue]);

    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Registrar atenci&oacute;n AHE" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Registrar atenci&oacute;n AHE"/>
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}/>
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando}/>
                    <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary">
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <input hidden {...register('beneficiariosahe')}/>
                            <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos}/>
                                <input hidden {...register('usrId')}/>
                                <input hidden {...register('cabIdcabezafamilia')}/>
                                <input hidden {...register('sedeActual')}/>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="fecha">Fecha entrega</label>
                                            <Controller
                                                control={control}
                                                id="fecha"
                                                name="fecha"
                                                render={({ field }) => (
                                                    <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                        <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput />}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)} // 30 días después de hoy
                                                        />
                                                    </div>
                                                )}
                                            />
                                            {errors.fecha && <p style={{color: 'red'}}>Digite fecha de entrega</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="idpersona">Integrante</label>
                                            <select id="idpersona" {...register('idpersona', { required: true })} className='form-control' disabled={disablefields}>
                                                {integrantes.map((option) => (
                                                <option key={option.per_idpersona} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                    <div id="divBeneficiariosAHE" className="col-md-6">
                                        <div className="form-group">
                                        <label htmlFor='beneficiariosahe'>Beneficiarios AHE</label>
                                        <Select
                                            id="beneficiariosahe"
                                            value={cualesBeneficiariosAHESeleccionados}
                                            isMulti
                                            name="beneficiariosahe"
                                            options={personas}
                                            onChange={ActualizarBeneficiariosAHE}
                                            className="basic-multi-select"
                                            classNamePrefix="Seleccione"
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999
                                                })
                                            }}
                                        />
                                        {errors.der_5_9_2_quien && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="entidad">Entidad:</label>
                                            <select id="entidad" {...register('entidad', { required: true })} className='form-control' disabled={disablefields}>
                                                {entidades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.entEntidad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="tipoahuid">Tipo ayuda humanitaria</label>
                                            <select id="tipoahuid" {...register('tipoahuid', { required: true })} className='form-control' onChange={ActualizarTiposEntrega} disabled={disablefields}>
                                                <option value="">Seleccionar</option>
                                                {tiposahu.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTipoahu}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoahuid && <p style={{color: 'red'}}>Seleccione tipo ayuda humanitaria</p>}
                                        </div>
                                    </div>
                                </div>
                                {MostrarTiposEntrega && <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="tipoentregaid">Tipo entrega</label>
                                            <select id="tipoentregaid" {...register('tipoentregaid', { required: true })} className='form-control' onChange={ActualizarNaturalezas} disabled={disablefields}>
                                                {tiposentrega.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTipoentrega}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoentregaid && <p style={{color: 'red'}}>Seleccione tipo entrega</p>}
                                        </div>
                                    </div>
                                </div>}
                                {MostrarTiposNaturaleza && <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="naturalezaid">Naturaleza Entrega:</label>
                                            <select id="naturalezaid" {...register('naturalezaid', { required: true })} className='form-control' disabled={disablefields}>
                                                {naturalezas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.id} {option.tipNaturaleza}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.naturalezaid && <p style={{color: 'red'}}>Seleccione naturaleza entrega</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="tiponaturalezaid">Tipo Naturaleza:</label>
                                            <select id="tiponaturalezaid" {...register('tiponaturalezaid', { required: true })} className='form-control' disabled={disablefields}>
                                                {tiposnaturaleza.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.id} {option.tipTiponaturaleza}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tiponaturalezaid && <p style={{color: 'red'}}>Seleccione tipo naturaleza entrega</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="idayuda">Tipo Ayuda:</label>
                                            <select id="idayuda" {...register('idayuda', { required: true })} className='form-control' onChange={ActualizarValorUnitario}>
                                                {ayudas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.ayu_ayuda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idayuda && <p style={{color: 'red'}}>Seleccione tipo ayuda</p>}
                                        </div>
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="valorunitario">Valor Unitario:</label>
                                            <Controller
                                                name="valorunitario"
                                                control={control}
                                                defaultValue=""
                                                render={({ field }) => (
                                                    <NumberInput id="valorunitario" {...field} />
                                                )}
                                            />
                                            {errors.valorunitario && <p style={{color: 'red'}}>Digite valor unitario</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="cantidad">Cantidad:</label>
                                            <Controller
                                                name="cantidad"
                                                control={control}
                                                defaultValue=""
                                                render={({ field}) => (
                                                    <NumberInput id="cantidad" {...field} />
                                                )}
                                            />
                                            {errors.cantidad && <p style={{color: 'red'}}>Digite cantidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="nropersonas">Nro personas:</label>
                                            <Controller
                                                name="nropersonas"
                                                control={control}
                                                defaultValue=""
                                                render={({ field}) => (
                                                    <NumberInput id="nropersonas" {...field} />
                                                )}
                                            />
                                            {errors.nropersonas && <p style={{color: 'red'}}>Digite numero personas</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="nroentrega">
                                                Nro entrega:
                                                <span
                                                    data-tooltip-id="tooltip-nroentrega"
                                                    data-tooltip-content="Número de veces que se ha entregado la ayuda a este beneficiario"
                                                    style={{ marginLeft: 6, cursor: "pointer", color: "#007bff" }}
                                                >
                                                    <FaInfoCircle />
                                                </span>
                                            </label>
                                            <Controller
                                                name="nroentrega"
                                                control={control}
                                                defaultValue=""
                                                render={({ field}) => (
                                                    <NumberInput id="nroentrega" {...field} />
                                                )}
                                            />
                                            {errors.nroentrega && <p style={{color: 'red'}}>Digite numero entrega</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea className='form-control' rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="card-footer">
                                {Cargando && <button type="submit" className="btn btn-primary" disabled>Agregar</button>}
                                {!Cargando && <button type="submit" className="btn btn-primary">Agregar</button>}
                            </div>
                            <div className='row'>
                                <div className="col-md-12">
                                    <div className="card-body table-responsive p-0">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Acciones</th>
                                                    <th>Ayuda</th>
                                                    <th>Tipo Entrega</th>
                                                    <th>Identificacion</th>
                                                    <th>Entidad</th>
                                                    <th>Cantidad</th>
                                                    <th>Nro Personas</th>
                                                    <th>Nro Entrega</th>
                                                    <th>Valor</th>
                                                    <th>Fecha</th>
                                                    <th>Observaciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getValues('atencionesfields') && getValues('atencionesfields').length === 0 ? (
                                                    <tr>
                                                        <td colSpan="10" className="text-center">
                                                            No hay datos para mostrar
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    getValues('atencionesfields') && getValues('atencionesfields').map((row, idx) => (
                                                        <tr key={row.idayuda || idx}>
                                                            <td>
                                                                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                                                                    <BotonBorrar Borrar={Borraratencion} row={row} />
                                                                </div>
                                                            </td>
                                                            <td>{row.ayuda}</td>
                                                            <td>
                                                                {tiposentrega.find(e => e.id === row.tipoentregaid?.toString())?.tipTipoentrega || ''}
                                                            </td>
                                                            <td>{row.idpersona}</td>
                                                            <td>{row.entidad}</td>
                                                            <td>{row.cantidad}</td>
                                                            <td>{row.nropersonas}</td>
                                                            <td>{row.nroentrega}</td>
                                                            <td>{Math.round(row.valor)}</td>
                                                            <td>{row.fecha instanceof Date ? row.fecha.toISOString().split('T')[0] : row.fecha}</td>
                                                            <td style={{ overflowWrap: 'break-word' }}>{row.observaciones}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                {Cargando && <button type="button" onClick={GuardarAtenciones} className="btn btn-primary" disabled>Guardar</button>}
                                {!Cargando && <button type="button" onClick={GuardarAtenciones} className="btn btn-primary">Guardar</button>}
                            </div>
                        </form>
                        </div>
                    </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            </section>
        </div>
    );
}